











import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import {ItrackCollection} from '@/helpers'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'
import {$, ObjectCollection} from 'simpli-web-sdk'

@Component
export default class ItMemberSelect extends Vue {
  @Prop({type: String, default: 'query'}) spinner!: string

  @Getter('auth/firstMemberOrNull') firstMemberOrNull!: Responsavel
  @Action('auth/auth') auth!: Function
  @Action('sentinel/reset') resetSentinel!: Function

  allFilial = ItrackCollection.allFilialFilter

  creating = true
  member: Responsavel | null = null

  @Watch('member', {deep: true})
  async memberEvent(member: Responsavel | null) {
    if (member && !this.creating) {
      this.$emit('memberRespEvent', member.$id)
      await member.persistFilial()
      await this.auth()
      this.resetSentinel()
      this.$emit('update', member.$id)
    }
  }

  created() {
    this.member = this.firstMemberOrNull ? this.firstMemberOrNull.clone() : null
  }

  async mounted() {
    await this.allFilial.query()
    this.allFilial.items.forEach((item: Responsavel) => {
      let nomeFantasia = ''
      if (item.nomeFantasia) {
        nomeFantasia = `${$.filter.truncate(item.nomeFantasia || '', 20)} - `
      }

      item.$tag = `${nomeFantasia}${Helper.cnpj(item.cnpj)}`
    })
    await this.$nextTick()
    this.creating = false
  }
}
